<template>
  <div class="container-fluid">
    <div class="row">
      <div class="offset-3 col-6">
        <h1>This is the base contacts page</h1>
        <ul v-if="posts && posts.length">
          <li v-for="post of posts" v-bind:key="post.id">
            <strong>{{ post.firstName }} {{ post.lastName }}</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ContactsService from '../services/contacts-service';
import toastr from '../common/toastr-util';

export default {
  data() {
    return {
      posts: []
    };
  },

  created() {
    this.contactsService = this.$serviceBus.$inject(
      'contactsService',
      ContactsService
    );
    this.contactsService.service
      .getAll()
      .then(response => {
        this.posts = response.data;
      })
      .catch(e => {
        toastr.toast('error', JSON.stringify(e));
      });
  }
};
</script>
